module.exports = __webpack_public_path__ + "static/media/18ECA9.8f17d049.jpg";